export default {
  title: "Parámetros del sistema"
  , form: {
    buzonu: { label: "Datos de carga" }
    , enableSFTPU: { label: "Habilitar carga por SFTP" }

    , buzond: { label: "Datos de descarga" }
    , enableSFTPD: { label: "Habilitar descarga por SFTP" }

    , encriptacion: { label: "Encriptación" }
    , enableZIP: { label: "Habilitar seguridad para archivos" }
    , passwordZIP: { label: "Contraseña" }

    , mail: { label: "Envío por correo electrónico" }
    , enableMail: { label: "Habilitar envío por correo electrónico" }
    , enableMailBases: { label: "Habilitar envío por correo electrónico de bases" }
    , numeroIntentos: { label: "Número de intentos" }
    , maxFileSize: { label: "Tamaño máximo de archivos a importar" }
    , maxFileSizeZip: { label: "Tamaño máximo de zip adjunto en correo" }

    , geolocalizacion: { label: "Geolocalización" }
    , geoPais: { label: "Clave País" }
    , geoPaisCompleto: { label: "Nombre del País" }
    , valoresMinimos: { label: "Valores mínimos aceptables" }
    , geoRelevanciaBuena: { label: "Relevancia Buena" }
    , geoRelevanciaRegular: { label: "Relevancia Regular" }
    , geoRelevanciaMala: { label: "Relevancia Mala" }
    , geocodeMapbox: { label: "Geolocalizar con Mapbox" }
    , geocodeGoogle: { label: "Geolocalizar con Google" }
    , geocodeGoogleRelMala: { label: "Geolocalizar con Google si Relevancia de Mapbox es Mala" }
    , geocodeGoogleRelRegular: { label: "Geolocalizar con Google si Relevancia de Mapbox es Regular" }
    , geocodeGoogleRelBuena: { label: "Geolocalizar con Google si Relevancia de Mapbox es Buena" }
    , geocodeGoogleImportarBases: { label: "Geolocalizar con Google al Importar Bases" }
  }
  , rules: {
    requerido: { text: "El valor es requerido" }
    , geoRelevancia: { text: "El valor debe de estar entre 0 y 1" }
  }
  , errors: {
    BD3000: { text: "Ocurrió un error en el catálogo de Parámetros" }
    , WS3000: { text: "Ocurrió un error en el catálogo de Parámetros" }
    , JS3000: { text: "Ocurrió un error en el catálogo de Parámetros" }
    , CR3000: { text: "Ocurrió un error en el catálogo de Parámetros" }
    , FT3000: { text: "Error en la conexión al SFTP" }
    , VH3000: { text: "Este registro de parámetros del sistema ha sido modificado por otro usuario" }
    , VS3000: { text: "Este registro de parámetros del sistema ha sido modificado por otro usuario" }
  }
};



// WEBPACK FOOTER //
// ./src/locales/languages/es_MX/view/generales/parametros.js